<div class="order-consultation mt-5 mb-50">
  <h1 class="order-header" *ngIf="heading== ''">Получить консультацию эксперта и последующий расчет ЭПБ документации на консервацию, ликвидацию ОПО</h1>
  <h1 class="order-header" *ngIf="heading!== ''">{{heading}}</h1>

  <form class="newRecall" name="recall" [formGroup]="formC">

    <div class="flex-column">
      <ng-container *ngIf="formStep===0">
        <p style="font-size: 13px; margin-bottom: 40px; color: grey;">
          Заполните форму для расчета стоимости
        </p>
        <div class="flex-column" style="gap: 40px;">
          <div class="flex-row" style="align-items: center">
            <div class="field field_long">

              <label for="id_uname">Ваше имя:</label>
              <input type="text" formControlName="name" name="uname" placeholder="Иван Васильевич" id="id_uname">
            </div>
            <p class="form-hint">
              Чтобы знать, как к вам обращаться
            </p>
          </div>
          <div class="flex-row" style="align-items: center">
            <div class="field">
              <input type="hidden" name="id_base" value="0" class="not-req">
              <input type="hidden" name="service_title" value="Обратный звонок, услуга не указана"
              >

              <label for="id_utel">Ваш телефон:</label>
              <input type="tel" formControlName="tel" name="utel" placeholder="+7 456 777-88-99" maxlength="20" id="id_utel">
            </div>
            <p class="form-hint">
              Номер телефона может потребоваться эксперту, если у него возникнут вопросы.
              Это существенно ускорит процесс расчета
            </p>
          </div>


        </div>
        <p class="badge-paragraph">
          Отправляя форму, я даю согласие на обработку моих персональных данных в рамках
          <br/>
          №&nbsp;152-ФЗ&nbsp;«О&nbsp;персональных данных» и&nbsp;соглашаюсь с&nbsp;политикой
          конфиденциальности
        </p>
      </ng-container>
      <ng-container *ngIf="formStep ===1">
        <div class="step step-survey" style="display: block;z-index: 3" [ngClass]="{'text-disabled': greyed}">
          <div class="w-100 mt-5" style="display: flex;gap: 50px; align-items: center;"><h3>Ответьте на вопросы для получения предложения<br/>и детальной консультации</h3>
            <button *ngIf="!greyed" type="button" class="button__submit call-me_btn miss_btn" (click)="greyed = true;"
            > Пропустить
            </button>
          </div>
          <ul [ngClass]="{'d-none': greyed}" id="vids_select" class="flat_type">

            <li class="lvl1">

              <label for="id_field_602_0">ОПО расположен в:</label>
              <ul id="id_field_602" class="flex-row">
                <li><label for="id_field_602_0" ><input type="radio" name="location" formControlName="location" value="Москве" id="id_field_602_0">
                  Москве</label>

                </li>
                <li><label for="id_field_602_1"><input type="radio" name="location" formControlName="location" value="Московской области" id="id_field_602_1">
                  Московской области</label>

                </li>
                <li><label for="id_field_602_2"><input type="radio" name="location" formControlName="location" value="Другом регионе" id="id_field_602_2">
                  Другом регионе</label>

                </li>
              </ul>



              <ul class="sub-menu" style="width:500px; float:left;"></ul>

              <div class="clear"></div>
              <div class="separator"></div>

            </li>
            <li class="lvl1">

              <label class="mt-4" for="id_field_602_0">Вам требуется:</label>
              <ul id="id_field_602" class="flex-row">
                <li><label ><input type="radio" name="require" formControlName="require"  value="Экспертиза промышленной безопасности" >
                  Экспертиза промышленной безопасности</label>

                </li>
                <li><label><input type="radio" name="require" formControlName="require"  value="Техническое освидетельствование" >
                  Техническое освидетельствование</label>

                </li>
                <li><label><input type="radio" name="require" formControlName="require"  value="Ликвидация / консервация ОПО" >
                  Ликвидация / консервация ОПО</label>

                </li><li><label><input type="radio" name="require" formControlName="require"  value="Паспортизация" >
                  Паспортизация</label>

                </li><li><label><input type="radio" name="require" formControlName="require"  value="Идентификация" >
                  Идентификация</label>

                </li>
                <li><label><input type="radio" name="require" formControlName="require"  value="Аудит" >
                  Аудит</label>

                </li><li><label><input type="radio" name="require" formControlName="require"  value="Консультация " >
                  Консультация</label>

                </li><li><label><input type="radio" name="require" formControlName="require"  value="Другое" >
                  Другое</label>

                </li>
              </ul>



              <ul class="sub-menu" style="width:500px; float:left;"></ul>

              <div class="clear"></div>
              <div class="separator"></div>

            </li>
            <li class="lvl1">

              <label class="mt-4" for="id_field_602_0">Ваш объект:</label>
              <ul id="id_field_602" class="flex-row">
                <li><label><input type="radio" value="Сеть газопотребления / котельная" formControlName="object" name="object">
                  Сеть газопотребления / котельная</label>

                </li>
                <li><label><input type="radio" value="ТЭК / нефтебаза / химия" formControlName="object" name="object">
                  ТЭК / нефтебаза / химия</label>

                </li>
                <li><label><input type="radio" value="Теплосеть" formControlName="object" name="object">
                  Теплосеть</label>

                </li><li><label><input type="radio"  value="Краны / подъемники" formControlName="object" name="object">
                Краны / подъемники</label>

              </li><li><label><input type="radio" value="Взрывчатые вещества" formControlName="object" name="object">
                Взрывчатые вещества</label>

              </li><li><label><input type="radio" value="Растительное сырье / элеваторы"  formControlName="object" name="object">
                Растительное сырье / элеваторы</label>

              </li><li><label><input type="radio" value="Металлургия"  formControlName="object" name="object">
                Металлургия</label>

              </li><li><label><input type="radio" value="Другое" formControlName="object" name="object">
                Другое</label>

              </li>
              </ul>



              <ul class="sub-menu" style="width:500px; float:left;"></ul>

              <div class="clear"></div>
              <div class="separator"></div>

            </li>


          </ul>

        </div>

      </ng-container>
      <ng-container *ngIf="formStep ===2">
        <h3 class="mt-4">
          {{formC.value.name}}, благодарим Вас за обращение!<br>
        </h3>
        <h3 class="mt-3"><span style="font-weight: 400">Номер вашей заявки</span><span
          style="color: #880000!important;"> №4597</span></h3>
        <p class="mt-3">
          Ваша заявка уже передана менеджерам, ожидайте звонка в течение ближайшего времени.
          <br>
          Если Вам требуется срочная консультация, мы всегда на связи в <a
          href="https://api.whatsapp.com/send/?phone=79150683978"
          style="color: #880000!important; text-decoration: underline; text-underline-offset: 2px">чате</a>
        </p>
      </ng-container>
      <div class="order-button_cont" *ngIf="formStep<2">

        <button type="button" class="button__submit call-me_btn" style="z-index: 5" (click)="formStep= formStep+1; submit() "
        ><span *ngIf="formStep === 0||1" style="color:white;">Далее</span>
        </button>

      </div>
    </div>
  </form>
</div>
